import { isEmpty } from 'validations';

export const validateAcademy = (academy) => {
	let isValid = true;
	let messages = [];

	if (isEmpty(academy.title)) {
		isValid = false;
		messages.push('Title is required');
	}

	if (isEmpty(academy.description)) {
		isValid = false;
		messages.push('Description is required');
	}

	let validation = {
		isValid,
		messages
	};

	return validation;
};
